import { Table, TableBody, TableCell, TableHead, TableRow, Theme, useMediaQuery } from '@mui/material';

import { formatDateToString } from '../../../utils/date';
import { getLockEventMessage } from '../../../utils/helpers';
import { BikeBoxLockEvent } from '../../../utils/types';

export type Props = {
    lockEventHistory: BikeBoxLockEvent[];
};

const LockEventHistoryTable = ({ lockEventHistory }: Props) => {
    const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>Dato</TableCell>
                    <TableCell>Navn</TableCell>
                    <TableCell>Type</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {lockEventHistory.map((lockEvent, index) => {
                    const lockEventMessage = getLockEventMessage(lockEvent.lockEventMessage);
                    return (
                        <TableRow key={lockEvent.timestamp}>
                            <TableCell>
                                {isMobile ? formatDateToString(new Date(lockEvent.timestamp), 'dd/MM/yyyy, kk:mm', true) : formatDateToString(new Date(lockEvent.timestamp), 'EEEE do MMMM yyyy kk:mm', true)}
                            </TableCell>
                            <TableCell>{lockEvent.personName}</TableCell>
                            <TableCell>{lockEventMessage}</TableCell>
                        </TableRow>
                    );
                })}
            </TableBody>
        </Table>
    );
};

export default LockEventHistoryTable;
